/* eslint-disable */
import axios from 'axios';
import { appendTokenToUrl } from '../components/context/Recaptcha';

const { config } = window.appAirDrop;
const { additionalHeaders, loginRootUrl } = config;

export async function postCreatePassword(createPwdData: any, escrow: any, recaptchaToken?: string) {
  const path = `${loginRootUrl}/login/createUserPassword/${escrow}`;
  const response = await axios.post(
    appendTokenToUrl(path, recaptchaToken),
    new URLSearchParams(createPwdData).toString(),
    {
      headers: {
        ...(additionalHeaders ?? {}),
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      withCredentials: true,
    },
  );

  return response;
}
